module.exports = __webpack_public_path__ + "static/media/connect-to-see-more.0c9bf326.webp";